// Close other nested dropdowns when one is opened
document.addEventListener('DOMContentLoaded', function() {
  // Get all nested dropdown details elements (inside .header__submenu)
  const nestedDropdowns = document.querySelectorAll('.header__submenu details');

  nestedDropdowns.forEach(dropdown => {
    dropdown.addEventListener('toggle', function() {
      if (this.open) {
        // Find the parent dropdown (the top-level dropdown)
        const parentDropdown = this.closest('ul.header__submenu');

        // Close all other nested dropdowns within the same parent
        if (parentDropdown) {
          const siblingDropdowns = parentDropdown.querySelectorAll('details');
          siblingDropdowns.forEach(sibling => {
            if (sibling !== this && sibling.open) {
              sibling.removeAttribute('open');
            }
          });
        }
      }
    });
  });
});
